import { Card, Classes, InputGroup } from "@blueprintjs/core";
import classNames from "classnames";
import _ from "lodash";
import React, { useState } from "react";

import { PlayCount } from "../../../components/playCount/play-count";
import { TagSortValues, useGetTags } from "../../../hooks";
import { getStringRandomLength } from "../../../utils";
import { TagItem } from "./tag-item";
import styles from "./tag.tab.module.scss";

export const Tags = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [sort, setSort] = useState<{ sortValue: TagSortValues; sortDirection: string }>({
    sortValue: TagSortValues.name,
    sortDirection: "asc",
  });

  const { tags, loading } = useGetTags({ searchTerm, sort });

  if (loading) return <LoadingTag />;

  const handleSort = (sortValue: TagSortValues) => {
    if (sort.sortValue === sortValue) {
      setSort({ sortValue, sortDirection: sort.sortDirection === "asc" ? "desc" : "asc" });
    } else {
      setSort({ sortValue, sortDirection: "asc" });
    }
  };

  return (
    <div className={styles.tagsCardContainer}>
      <Card className={styles.card}>
        <div className={styles.searchContainer}>
          <InputGroup
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            large={true}
            placeholder="Search"
            leftIcon="search"
            className={styles.search}
            rightElement={searchTerm ? <PlayCount playCount={tags.length} /> : <></>}
          />
        </div>
        <div className={styles.tagContainer}>
          <div className={styles.tagHeader}>
            <div className={styles.tagTitle} onClick={() => handleSort(TagSortValues.name)}>
              Tag
            </div>
            <div className={styles.tagNumberContainer}>
              <div className={classNames(styles.numbersHeader)} onClick={() => handleSort(TagSortValues.noOfPlays)}>
                Plays
              </div>
              <div
                className={classNames([styles.numbersHeader])}
                onClick={() => handleSort(TagSortValues.noOfPlayBooks)}
              >
                Playbooks
              </div>
            </div>
          </div>

          {tags.map((tag) => (
            <TagItem tag={tag} key={tag.id} />
          ))}
        </div>
      </Card>
    </div>
  );
};

const LoadingTag = () => {
  // create fakeTag array with 40 items
  const fakeTag = _.range(40);

  return (
    <div className={styles.tagContainer}>
      <div className={styles.tagHeader}>
        <div className={classNames(styles.tagTitle, Classes.SKELETON)}>Tag</div>
        <div className={classNames(styles.numbersHeader, Classes.SKELETON)}># of Plays</div>
      </div>

      {fakeTag.map((tag, index) => (
        <LoadingTagItem key={index} />
      ))}
    </div>
  );
};

const LoadingTagItem = () => {
  return (
    <div className={styles.tagItem}>
      <div className={styles.tagDisplayContainer}>
        <div>
          <span className={Classes.SKELETON}>{getStringRandomLength(8, 20)}</span>
        </div>
      </div>
      <div className={styles.tagInfoEditContainer}>
        <div className={styles.tagsNumber}>
          <span className={Classes.SKELETON}>{getStringRandomLength(1, 3)}</span>
        </div>
      </div>
    </div>
  );
};
